import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthHandlerInterceptor } from './interceptors/auth-handler/auth-handler.interceptor';


@NgModule({
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthHandlerInterceptor, multi: true },
  ]
})
export class CoreModule { }
